import { cn } from '@fidalia/ui';
import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import {
  MdErrorOutline,
  MdExtension,
  MdOutgoingMail,
  MdSettingsSuggest,
  MdSync,
} from 'react-icons/md';

export const Route = createFileRoute('/_app/docs')({
  component: DocumentationLayout,
});

/** Le plan : une rubrique par grand sujet, et une page (une adresse) par section. */
const PLAN = [
  {
    titre: 'Emails',
    icone: <MdOutgoingMail />,
    pages: [{ to: '/docs/delivery-failures', titre: 'Échecs d’envoi', icone: <MdErrorOutline /> }],
  },
  {
    titre: 'Extension',
    icone: <MdExtension />,
    pages: [
      {
        to: '/docs/sync',
        titre: 'Synchronisation',
        icone: <MdSettingsSuggest />,
      },
      { to: '/docs/appointment-sync', titre: 'Synchronisation RDV', icone: <MdSync /> },
    ],
  },
] as const;

/** Documentation interne : le plan à gauche, la page ouverte à droite. */
function DocumentationLayout() {
  return (
    <div className="grid gap-6 lg:gap-10 lg:grid-cols-[14rem_minmax(0,1fr)]">
      <nav aria-label="Plan de la documentation">
        <div className="flex flex-col gap-6 rounded-card border border-border-subtle bg-surface p-4 shadow-card lg:sticky lg:top-0">
          <p className="text-xs font-semibold uppercase tracking-wide text-content-subtle">
            Documentation
          </p>
          {PLAN.map((rubrique) => (
            <div key={rubrique.titre} className="flex flex-col gap-2">
              <p className="flex items-center gap-2 text-sm font-semibold text-content">
                <span aria-hidden="true" className="text-lg text-content-subtle">
                  {rubrique.icone}
                </span>
                {rubrique.titre}
              </p>
              <ul className="flex flex-col gap-1 border-l border-border-subtle">
                {rubrique.pages.map((page) => (
                  <li key={page.to}>
                    <Link
                      to={page.to}
                      className={cn(
                        '-ml-px flex items-center gap-2 border-l border-transparent py-1.5 pl-3 text-sm text-content-muted transition-colors hover:border-border-input hover:text-content',
                      )}
                      activeProps={{
                        className: '!border-brand-600 !font-medium !text-brand-600',
                        'aria-current': 'page',
                      }}
                    >
                      <span aria-hidden="true" className="text-base">
                        {page.icone}
                      </span>
                      {page.titre}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </nav>

      <Outlet />
    </div>
  );
}
